import React from 'react'
import "./LoadingForButton.scss"
import loadingSVG from "../../assets/images/Loading-three-dots.svg";
const LoadingForButton = () => {
    return (
        <img className='loading' src={loadingSVG} alt="#" />
        // <div className="snippet"  >
        //     <div className="stage">
        //         <div className="dot-pulse"></div>
        //     </div>
        // </div>
    )
}

export default LoadingForButton